<mat-card appearance="outlined">
    <mat-card-header>
        <h2>Theme</h2>
    </mat-card-header>
    <mat-card-content>
        <section>
            <mat-button-toggle-group #themeApp="matButtonToggleGroup" [value]="theme" (change)="themeChange($event.value)" hideSingleSelectionIndicator="true">
                <mat-button-toggle value="light" title="Claro"><mat-icon>light_mode</mat-icon></mat-button-toggle>
                <mat-button-toggle value="dark" title="Escuro"><mat-icon>dark_mode</mat-icon></mat-button-toggle>
                <mat-button-toggle value="system" title="Seguir o sistema"><mat-icon>brightness_auto</mat-icon></mat-button-toggle>
            </mat-button-toggle-group>
        </section>
    </mat-card-content>
</mat-card>

<mat-card appearance="outlined">
    <mat-card-header>
        <h2>Sidenav</h2>
    </mat-card-header>
    <mat-card-content>
        <section>
            <mat-button-toggle-group #mode="matButtonToggleGroup" [value]="modeNav" (change)="onModeChange(mode.value)" hideSingleSelectionIndicator="true" >        
                <mat-button-toggle value="push">Push</mat-button-toggle>
                <mat-button-toggle value="over">Over</mat-button-toggle>
                <mat-button-toggle value="side">Side</mat-button-toggle>
            </mat-button-toggle-group>
            &nbsp;&nbsp;
            <mat-button-toggle-group #size="matButtonToggleGroup" [value]="sizeNav" (change)="onSizeChange(size.value)" hideSingleSelectionIndicator="true" >        
                <mat-button-toggle value="sidenav">Normal</mat-button-toggle>
                <mat-button-toggle value="collaped">Mini</mat-button-toggle>
            </mat-button-toggle-group>
        </section>
    </mat-card-content>
</mat-card>

<mat-card appearance="outlined">
    <mat-card-header>
        <h2>Notification</h2>
    </mat-card-header>
    <mat-card-content>
        <section>
            <mat-button-toggle-group #notification="matButtonToggleGroup" [value]="notificationStatus" (change)="notificationToggle()" hideSingleSelectionIndicator="true">        
                <mat-button-toggle value="on"><mat-icon>notifications_active</mat-icon></mat-button-toggle>
                <mat-button-toggle value="off"><mat-icon>notifications_off</mat-icon></mat-button-toggle>
            </mat-button-toggle-group>
        </section>
    </mat-card-content>
</mat-card>

<mat-card appearance="outlined">
    <mat-card-header>
        <h2>Trusted devices</h2>
    </mat-card-header>
    <mat-card-content>
        <p class="hint">Devices where the authenticator code is not asked for 30 days. Remove one to ask for the code again on it.</p>
        <p class="hint" *ngIf="!trustedDevices.length">No trusted devices. To add this one, check "Lembrar este dispositivo por 30 dias" when entering the authenticator code.</p>
        <div class="device" *ngFor="let device of trustedDevices">
            <mat-icon class="device-icon">devices</mat-icon>
            <div class="device-info">
                <span class="device-name">{{ device.label }} <span class="current" *ngIf="device.current">this device</span></span>
                <span class="device-dates">
                    Last used {{ device.lastUsedAt | date:'dd/MM/yyyy HH:mm' }} · expires {{ device.expiresAt | date:'dd/MM/yyyy' }}
                </span>
            </div>
            <button mat-icon-button (click)="revokeDevice(device)" [disabled]="isRevoking" [attr.aria-label]="'Remove ' + device.label" title="Remove">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
        <button mat-stroked-button *ngIf="trustedDevices.length > 1" (click)="revokeAllDevices()" [disabled]="isRevoking">Remove all</button>
    </mat-card-content>
</mat-card>
